module.exports = __webpack_public_path__ + "img/sup_wallet_2.1f9e1b91.jpg";